<ion-card class="CSAT-card main-block w-100 ion-padding ion-no-margin ion-margin-bottom cursor-pointer"
  [class.card-disabled]="isRedirectInProgress"
  [attr.aria-disabled]="isRedirectInProgress"
  [attr.tabindex]="isRedirectInProgress ? -1 : 0"
  (click)="redirectToSurvey()" (keydown.enter)="redirectToSurvey()">
  <!-- CSAT call-to-action content -->
  <div class="d-flex align-items-center">
    <!-- CSAT icon -->
    <ion-icon class="CSATIcon" [src]="'assets/icon/' + csatDetails()?.surveY_FORM_CALL_TO_ACTION_ICON">
    </ion-icon>

    <!-- CSAT text content -->
    <div class="text-wrapper nameState d-flex flex-column">
      <!-- CSAT title -->
      <div [innerHTML]="csatDetails()?.surveY_FORM_CALL_TO_ACTION_TITLE">
      </div>

      <!-- CSAT subtitle -->
      <div class="actionSubTitle" [innerHTML]="csatDetails()?.surveY_FORM_CALL_TO_ACTION_SUBTITLE">
      </div>
    </div>
  </div>
</ion-card>